import { useState } from 'react';
import { SidebarLeftCollapseIcon } from 'foundations-assets/icons/components/SidebarLeftCollapseIcon';
import { SidebarRightCollapseIcon } from 'foundations-assets/icons/components/SidebarRightCollapseIcon';
import { SidebarLeftExpandIcon } from 'foundations-assets/icons/components/SidebarLeftExpandIcon';
import { SidebarRightExpandIcon } from 'foundations-assets/icons/components/SidebarRightExpandIcon';
import { CollapsiblePanelHeader } from './CollapsiblePanelHeader';
import { PanelWrapper, ContentWrapper } from './CollapsiblePanelStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SidebarPanel({
  borderSide,
  expandAriaLabel,
  collapseAriaLabel,
  expandTooltip,
  collapseTooltip,
  title,
  side = 'left',
  flushBody,
  children,
  'data-test-id': dataTestId
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const resolvedExpandTooltip = expandTooltip !== null && expandTooltip !== void 0 ? expandTooltip : expandAriaLabel;
  const resolvedCollapseTooltip = collapseTooltip !== null && collapseTooltip !== void 0 ? collapseTooltip : collapseAriaLabel;
  const expandIcon = side === 'left' ? /*#__PURE__*/_jsx(SidebarLeftExpandIcon, {
    color: "icon-core-default",
    size: "800"
  }) : /*#__PURE__*/_jsx(SidebarRightExpandIcon, {
    color: "icon-core-default",
    size: "800"
  });
  const collapseIcon = side === 'left' ? /*#__PURE__*/_jsx(SidebarLeftCollapseIcon, {
    color: "icon-core-default",
    size: "800"
  }) : /*#__PURE__*/_jsx(SidebarRightCollapseIcon, {
    color: "icon-core-default",
    size: "800"
  });
  const icon = isCollapsed ? expandIcon : collapseIcon;
  return /*#__PURE__*/_jsxs(PanelWrapper, {
    $isCollapsed: isCollapsed,
    $borderSide: borderSide,
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/_jsx(CollapsiblePanelHeader, {
      isCollapsed: isCollapsed,
      onToggle: () => setIsCollapsed(!isCollapsed),
      tooltip: isCollapsed ? resolvedExpandTooltip : resolvedCollapseTooltip,
      ariaLabel: isCollapsed ? expandAriaLabel : collapseAriaLabel,
      icon: icon,
      title: title
    }), /*#__PURE__*/_jsx(ContentWrapper, {
      $isCollapsed: isCollapsed,
      $flushBody: flushBody,
      children: !isCollapsed && children
    })]
  });
}